import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const analyticsConfigSelector = ({ analyticsConfig }: ReducerState) => analyticsConfig;
export const analyticsConfigLoadingSelector = createSelector(
  analyticsConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
